
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Module} from './module';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class ModuleService
{
    

    constructor(private http: HttpClient) { 

    }
    token = environment.token;
    moduleurl = environment.appURL+"/modules";
  
   

 getModules() 
{
  return this.http.get<Module[]>(this.moduleurl,{headers: new HttpHeaders({"Authorization":"Bearer " + this.token})})
  .pipe(
    tap(_ => console.log('fetched modules')),
    catchError(this.handleError('getModules', []))
  );
}

getModule(id: number)
{
  const url = `${this.moduleurl}/${id}`;
  console.log(url);
  return this.http.get<Module>( url,{headers: new HttpHeaders({"Authorization":"Bearer " + this.token})})
  .pipe(
    tap(_ => console.log('fetched modules')),
    catchError(this.handleError<Module>(`getModule id=${id}`))
  );
 }


 updateModule (module: Module): Observable<any> {
   let upd = "module=" + module.module 
  return this.http.put(this.moduleurl +"/"+ module.id, upd , {headers: new HttpHeaders({"Authorization":"Bearer " + this.token, "Content-Type": "application/x-www-form-urlencoded"})})
  .pipe(
    tap(_ => console.log(`updated module id=${module.id}`)),
    catchError(this.handleError<any>('updateModule'))
  );
}


private handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
  
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead
  
      // TODO: better job of transforming error for user consumption
      console.log(`${operation} failed: ${error.message}`);
  
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

}